module.exports = __webpack_public_path__ + "img/6210806.jpg";